import { gql } from "@apollo/client";

import {
  REVIEW_FIELDS,
  REVIEW_GAME_FIELDS,
} from "@/components/review-modal/graphql";

import { USER_FIELDS_FRAGMENT } from "../profile/graphql";

const GAME_FIELDS_FRAGMENT = gql`
  fragment ReviewGameFields on GameType {
    id
    communityScorePercentages {
      percentage
      rating
    }
    communityRatingCount
    gameimageSet {
      id
      imageId
    }
    isCompleted @include(if: $isUser)
    isSaved @include(if: $isUser)
    location {
      id
      company {
        id
        name
      }
      displayName
    }
    name
    overallRating @include(if: $isUser)
    primaryCategory {
      id
      name
      slug
      parent {
        id
        name
        slug
      }
    }
    secondaryCategories {
      id
      name
      slug
    }
    slug
    userReview {
      id
      isContainingSpoilers
      overallRating
      summary
    }
  }
`;

export const QUERY = gql`
  ${GAME_FIELDS_FRAGMENT}

  ${REVIEW_GAME_FIELDS}

  ${REVIEW_FIELDS}

  ${USER_FIELDS_FRAGMENT}

  query UserReviews(
    $filters: GameFiltersInput
    $includeReview: Boolean!
    $isSSR: Boolean!
    $isUser: Boolean!
    $page: Int
    $pageSize: Int
    $reviewId: ID!
    $sortBy: GameSortByOptions
    $username: String!
  ) {
    games(
      filters: $filters
      page: $page
      pageSize: $pageSize
      reviewedOnly: true
      sortBy: $sortBy
      username: $username
    ) {
      hasNext
      objects {
        ...ReviewGameFields
      }
      page
    }
    facets: games(reviewedOnly: true, username: $username) @include(if: $isSSR) {
      facets {
        type
        items {
          id
          count
          name
          parentId
          slug
        }
      }
    }
    review(id: $reviewId) @include(if: $includeReview) {
      ...ReviewFields
    }
    user(username: $username) {
      ...UserFields
    }
  }
`;
